import { render, staticRenderFns } from "./transaction.vue?vue&type=template&id=6778f37f&scoped=true&"
import script from "./transaction.vue?vue&type=script&lang=js&"
export * from "./transaction.vue?vue&type=script&lang=js&"
import style0 from "./transaction.vue?vue&type=style&index=0&id=6778f37f&lang=scss&scoped=true&"
import style1 from "./transaction.vue?vue&type=style&index=1&lang=css&"
import style2 from "./transaction.vue?vue&type=style&index=2&id=6778f37f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778f37f",
  null
  
)

export default component.exports